module.exports = __webpack_public_path__ + "static/media/Lock.9f4625e2.svg";